import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import DictionaryItemMenu from '@/views/pages/Dictionary/elements/DictionaryItemMenu';

const DictionaryItem = ({ data, onEditItem, onDeleteItem }) => {
	const { dict } = useSelector((state) => state.app);

	return (
		<div className='table__dictionary__item'>
			<div className='table__dictionary__item--col col-flex'>
				<div className='table__dictionary__item--col-label'>{dict.dictionary.inputPhrase}:&nbsp;</div>
				{data.inputPhrase}
			</div>
			<div className='table__dictionary__item--col col-flex'>
				<div className='table__dictionary__item--col-label'>{dict.dictionary.outputPhrase}:&nbsp;</div>
				{data.outputPhrase}
			</div>
			<div className='table__dictionary__item--col col-flex'>
				<div className='table__dictionary__item--col-label'>{dict.dictionary.basicInputPhrase}:&nbsp;</div>
				{data.basicInputPhrase || '-'}
			</div>
			<div className='table__dictionary__item--col col-flex'>
				<div className='table__dictionary__item--col-label'>{dict.dictionary.basicOutputPhrase}:&nbsp;</div>
				{data.basicOutputPhrase || '-'}
			</div>
			<div className='table__dictionary__item--col col-flex'>
				<div className='table__dictionary__item--col-label'>{dict.dictionary.comments}:&nbsp;</div>
				{data.comments || '-'}
			</div>
			<div className='table__dictionary__item--col col-flex'>
				<div className='table__dictionary__item--col-label'>{dict.dictionary.count}:&nbsp;</div>
				{data.count || '0'}
			</div>
			{(data.rights.canEdit || data.rights.canDelete) && <div
				className='table__dictionary__item--col col-flex'
				style={ { overflow: 'unset' } }
			>
				<DictionaryItemMenu
					onEditItem={ onEditItem }
					onDeleteItem={ onDeleteItem }
					data={ data }
				/>
			</div>}
		</div>
	);
};

export default memo(DictionaryItem);